import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { FEATURES } from '@app/core/constants/features.constant';
import { FeatureFlagService } from '@app/core/services/feature-flag.service';
import { StatusTextType } from '@app/shared/status-text/status-text.model';
import { take } from 'rxjs';

@Component({
  selector: 'app-settings-sidebar',
  templateUrl: './settings-sidebar.component.html',
  styleUrls: ['./settings-sidebar.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class SettingsSidebarComponent implements OnInit {
  @Input() isSidebarExpanded = true;

  hasSelfRegistrationFeature = false;
  StatusTextType = StatusTextType;

  constructor(
    public router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.featureFlagService
      .isFeatureFlagEnabled(FEATURES.SELF_REGISTRATION)
      .pipe(take(1))
      .subscribe(isEnabled => {
        this.hasSelfRegistrationFeature = isEnabled;
      });
  }
}
